export default __webpack_public_path__ + "static/media/lottery.7f49cf81.png";